import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchUsers,
  filterUsers,
  fetchUserByID,
  selectUsers,
  fetchMoreUsers,
  getFullList,
} from "./usersSlice";

import Grid from "@material-ui/core/Grid";
import UsersList from "./UsersList";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function UsersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [userNames, setUserNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  const { users, loading, usersList, lastQuery, usersAmount } =
    useSelector(selectUsers);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User #",
      long: false,
      sortable: true,
    },
    {
      id: "firstName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "First Name",
      long: false,
    },
    {
      id: "lastName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Name",
      long: false,
    },
    {
      id: "displayName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Display Name",
      long: false,
      sortable: true,
    },
    {
      id: "username",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Username",
      long: false,
    },
    {
      id: "email",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Email",
      long: false,
    },
    {
      id: "mobile",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Mobile",
      long: false,
    },
    {
      id: "role",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User Role",
      long: false,
    },
    {
      id: "statusID",
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Status",
      checked: true,
      long: false,
    },
    {
      id: "createdAt",
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Created Date",
      checked: true,
      long: false,
    },
    {
      id: "updatedAt",
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Last Updated",
      checked: true,
      long: false,
    },
  ];
  const [rowList, setRowList] = useState([...headCells]);

  const handleUsersChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedUser = usersList.filter(
      (user) => user.displayName === event.target.value
    );
    selectedUser && idsArr.push(selectedUser[0].id);
    // });

    setUserNames(event.target.value);
    setUserIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchUsers({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset: rowsPerPage > usersList.length ? rowsPerPage : usersList.length,
        query: searchQuery,
        targetLength: usersAmount,
      })
    );
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleEdit = (id) => {
    dispatch(
      fetchUserByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchUserByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (usersList.length < usersAmount && usersList.length < expectedLen) {
        dispatch(
          fetchMoreUsers({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (usersList.length == usersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchUsers({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchUsers({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setUserNames([]);
    setUserIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchUsers({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = ["status"];

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <UsersList
        users={users}
        handleUsersChange={handleUsersChange}
        userNames={userNames}
        userIDs={userIDs}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        noChecks={true}
        headCells={headCells}
        rowList={rowList}
        setRowList={setRowList}
        productsAmount={usersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
